import React, { useState } from 'react';
import InputRange from 'react-input-range';
import styles from './step3.module.scss';
import { sliderDefaultClasses } from '../../constants';

const initialState: any = 80;

export const FeedPercentageSlider: React.FC<{
  value?: number;
  setValue: Function;
}> = props => {
  const [feedPercentage, setState] = useState(props.value || initialState);

  const setPercentage = (percentage: any) => {
    if (percentage < 40) {
      return false
    }
    setState(percentage);
    props.setValue(percentage);
  };

  return (
    <>
      <InputRange
        classNames={sliderDefaultClasses}
        maxValue={100}
        minValue={0}
        value={feedPercentage}
        step={1}
        formatLabel={value => `${value}%`}
        onChange={value => {
          setPercentage(value);
        }}
      />
    </>
  );
};
